import agentIa from './trainings/agent-ia'
import mcp from './trainings/mcp'
import vuejs from './trainings/vuejs'
import webApi from './trainings/web-api'
import react from './trainings/react'
import dotnet from './trainings/dotnet'

export default {
  trainings: [agentIa, mcp, vuejs, webApi, react, dotnet],
  convictions: [
    {
      id: 1,
      icon: require('@/assets/home/animated/Diamond.png'),
      iconStep: 84,
      animationDuration: 6,
      text: 'UN CODE CLAIR ET CONCIS'
    },
    {
      id: 2,
      icon: require('@/assets/home/animated/Bulb.png'),
      iconStep: 144,
      animationDuration: 6,
      text: 'RÉFLÉCHIR AVANT D\'AGIR'
    },
    {
      id: 3,
      icon: require('@/assets/home/animated/MagnifyingGlass.png'),
      iconStep: 144,
      animationDuration: 6,
      text: 'REVUE DU CODE'
    },
    {
      id: 4,
      icon: require('@/assets/home/animated/Progresser.png'),
      iconStep: 144,
      animationDuration: 6,
      text: 'APPRENTISSAGE EN CONTINU'
    }
  ],
  questions: [
    {
      id: 1,
      open: false,
      content: 'La formation peut-elle avoir lieu dans les locaux de ma société ?',
      response: [
        {
          id: 1,
          content: 'Nos formateurs ont l\'habitude de se déplacer en île-de-France et d\'animer des formations à l\'extérieur de notre centre de formation. Pour des déplacements hors île-de-France, des frais de déplacements seront appliqués.'
        }
      ]
    },
    {
      id: 2,
      open: false,
      content: 'Quel est le déroulement d\'une formation ?',
      response: [
        {
          id: 1,
          content: 'Les formations ont lieu dans les locaux de L\'Atelier en plein coeur de la capitale : 46 rue de L\'Arbre-Sec, 75001 Paris.'
        },
        {
          id: 2,
          content: 'Elles débutent à 10h et se terminent à 18h. Le centre est ouvert dès 9h30 et un petit déjeuner d\'accueil vous est proposé avant le début de la formation. Une pause d\'une heure et demi est réservée au déjeuner.'
        }
      ]
    },
    {
      id: 3,
      open: false,
      content: 'Comment trouver la formation répondant à mes attentes ?',
      response: [
        {
          id: 1,
          content: 'L\'Atelier encourage les formations sur-mesure adaptées aux besoins et au niveau des participants. Contactez-nous et faites-nous part de vos attentes, nos formateurs sauront alors ajuster leur discours ou même organiser une formation sur un sujet qui n\'est pas détaillé sur ce site.'
        }
      ]
    },
    {
      id: 4,
      open: false,
      content: 'Le centre de formation de L\'Atelier est-il homologué ?',
      response: [
        {
          id: 1,
          content: 'Numéro d\'agrément : 11 75 571 6675'
        }
      ]
    },
    {
      id: 5,
      open: false,
      content: 'L\'Atelier accepte-t-il la prise en charge OPCA ?',
      response: [
        {
          id: 1,
          content: 'L\'Atelier accepte les prises en charge OPCA.'
        },
        {
          id: 2,
          content: '- la prise en charge doit être totale et couvrir l\'ensemble du coût de la formation.'
        },
        {
          id: 3,
          content: '- l\'accord de prise en charge doit nous parvenir au plus tard 5 jours avant la session de formation.'
        }
      ]
    },
    {
      id: 6,
      open: false,
      content: 'Qui sont les formateurs ?',
      response: [
        {
          id: 1,
          content: 'Nos formateurs sont avant tout des experts passionnés par le développement et le partage de leurs connaissances. Ils développent au quotidien et participent activement dans les différentes communautés techniques.'
        }
      ]
    }
  ],
  infos: [
    {
      icon: require('@/assets/home/animated/Pen.png'),
      iconStep: 122,
      animationDuration: 6,
      title: 'SUR-MESURES',
      text: 'Des formations adaptées à <br/>votre problématique'
    },
    {
      icon: require('@/assets/home/animated/Engineer.png'),
      iconStep: 143,
      animationDuration: 6,
      title: 'COMPLÈTES',
      text: 'Maîtrise de l\'ensemble des technologies actuelles'
    },
    {
      icon: require('@/assets/home/animated/Brain.png'),
      iconStep: 96,
      animationDuration: 6,
      title: 'ACCESSIBLES',
      text: 'À partir de tous niveaux'
    }
  ]
}
